(() => {
  const init = (root) => {
    root.querySelectorAll('[data-fms-film]').forEach((film) => {
      if (film.dataset.ready) return;
      film.dataset.ready = 'true';
      const video = film.querySelector('video');
      const button = film.querySelector('[data-fms-play]');
      const label = button?.querySelector('[data-fms-label]');
      const frame = film.querySelector('.fms__frame');
      const error = film.querySelector('[data-fms-error]');
      if (!video || !button || !label) return;
      const sync = () => {
        const playing = !video.paused && !video.ended;
        button.dataset.playing = String(playing);
        frame.classList.toggle('is-playing', playing);
        label.textContent = playing ? 'Pause production video' : 'Watch the production line';
      };
      const fail = () => {
        button.removeAttribute('aria-busy');
        if (error) error.hidden = false;
        sync();
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        if (!video.paused) { video.pause(); return; }
        if (button.getAttribute('aria-busy') === 'true') return;
        if (error) error.hidden = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = 'Loading video…';
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.play().catch(fail);
      });
      video.addEventListener('playing', () => {
        button.removeAttribute('aria-busy');
        frame.classList.add('has-played');
        sync();
      });
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      video.addEventListener('error', fail);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
